import React, { useEffect, useState } from 'react'
import { LoadingStatus } from '../../../../@types/enumsGlobal';
import { ImportInvoicesModalWindow } from '../../../../components/modalWindows/ImportInvoicesModalWindow';
import { IDataForMoveFiles } from '../../../../libs/coreapi-dto/dirs/importInvoices';
import { IImportedStatusList } from '../../../../libs/coreapi-dto/documents/importedInvoice';
import { ImportedInvoiceDataProvider } from '../../../../Services/DataProviders/ImportedInvoiceDataProvider';
import { useAppContext } from '../../../../system/providers/appContextProvider';
import { useTranslation } from 'react-i18next';

interface IImportInvoicesCompletedModalWindowProps {
    cancel: () => void
    setLoadingStatus: (value: LoadingStatus) => void
    openBunchTab: (items, idInvoice, isSucceed, dataForMoveInvoices, callbackAfterImport, supplierDocNum) => void
    crashedInvoices: IImportedStatusList[]
    succeedInvoice: IImportedStatusList[]
    refresh: () => void
    dataForMoveInvoices: IDataForMoveFiles
    callbackAfterImport: ()=>void
    isLoading?: boolean
    setIsLoading?: (value: boolean) => void
}
export const ImportInvoicesCompletedModal: React.FC<IImportInvoicesCompletedModalWindowProps> = props => {
    const appCtx = useAppContext();
    const importedInvoiceDataProvider = new ImportedInvoiceDataProvider(appCtx.coreApiService);

    const openBunchWindow = async () => {
        if (props.setIsLoading) {
            props.setIsLoading(true);
        }
        try {
            // Собираем все промисы для параллельного выполнения
            const succeedPromises = props.succeedInvoice.map(x => 
                new Promise((resolve) => {
                    importedInvoiceDataProvider.getById(x.idImportedInvoiceGlobal, (e) => {
                        props.openBunchTab(
                            [...e.items.map(i => {
                                let c = x.typeBunches.find(z => z.idInvoiceItem === i.idGlobal);
                                return ({ 
                                    ...i, 
                                    success: true, 
                                    type: c?.type, 
                                    supplierVat: i.supplierCostInfo?.vat ?? 0 
                                })
                            })],
                            x.idImportedInvoiceGlobal,
                            x.isSucceed,
                            props.dataForMoveInvoices,
                            e.supplierDocNum,
                            props.callbackAfterImport
                        );
                        resolve(null);
                    });
                })
            );

            const crashedPromises = props.crashedInvoices.map(x => 
                new Promise((resolve) => {
                    importedInvoiceDataProvider.getById(x.idImportedInvoiceGlobal, (e) => {
                        let errorList = x.errorsList.map(x => x.split(' ')[0]);
                        props.openBunchTab(
                            [...e.items.map(i => {
                                let c = x.typeBunches.find(z => z.idInvoiceItem === i.idGlobal);
                                return ({ 
                                    ...i, 
                                    success: errorList.find(y => y === i.idGlobal) ? false : true, 
                                    type: c?.type, 
                                    supplierVat: i.supplierCostInfo?.vat ?? 0 
                                })
                            })],
                            x.idImportedInvoiceGlobal,
                            x.isSucceed,
                            props.dataForMoveInvoices,
                            e.supplierDocNum,
                            props.callbackAfterImport
                        );
                        resolve(null);
                    });
                })
            );

            // Ждем выполнения всех запросов
            await Promise.all([...succeedPromises, ...crashedPromises]);
            
        } catch (error) {
            console.error('Error in openBunchWindow:', error);
        } finally {
            if (props.setIsLoading) {
                props.setIsLoading(false);
            }
        }
    }

    const returnMessage = () => {
        if (props.crashedInvoices.length > 0 && props.succeedInvoice.length > 0) {
            const errorsByFile = props.crashedInvoices
                .map(inv => `${inv.idImportedInvoiceGlobal}: ${inv.errorsList.join(', ')}`)
                .join(' | ');

            return `В ${props.crashedInvoices.length} документе ошибки: [${errorsByFile}]. 
                    ${props.succeedInvoice.length} исправны, откроются окна для подтверждения`;
        } else if (props.crashedInvoices.length > 0 && props.succeedInvoice.length <= 0) {           
            return  `
                При импорте накладных произошла ошибка: \n  
                ${props.crashedInvoices.map((x) : string => {
                    return x.errorsList.map(el => {
                        const deleteId = el.split(' ').slice(1).join(" ");
                        return deleteId.charAt(0).toUpperCase() + deleteId.slice(1);
                    }).join("\n")
                })}
            `
        } else if (props.crashedInvoices.length <= 0 && props.succeedInvoice.length > 0) {
            return `${props.succeedInvoice.length} накладная(ых) исправны, откроются окна подтверждения`
        } else if (props.crashedInvoices.length === 0 && props.succeedInvoice.length === 0) {
            return 'При импорте накладных произошла ошибка.'
        }
    }

    function clearImportedInvoices()
    {
        props.succeedInvoice.forEach(x => {
            importedInvoiceDataProvider.deleteImportedInvoice(x.idImportedInvoiceGlobal);
        })
        props.crashedInvoices.forEach(x => {
            importedInvoiceDataProvider.deleteImportedInvoice(x.idImportedInvoiceGlobal);
        })
    }

    useEffect(() => {
        const handleTabClose = (event) => {
            clearImportedInvoices();
            return (event.returnValue = "");
        };

        window.addEventListener("beforeunload", handleTabClose);

        return () => {
            window.removeEventListener("beforeunload", handleTabClose);
        };
    }, []);        

    return (
        <ImportInvoicesModalWindow
            ok={{
                onClick: () => {
                    openBunchWindow()
                    props.cancel()
                }
            }}
            cancel={{ onClick: () => {
                clearImportedInvoices();
                props.cancel();
            }}}
        >
        {
            returnMessage()?.split("\n").map((x, index) => <p key={index}>{x}</p>)
        }
        </ImportInvoicesModalWindow>
    )
};